<template>
  <cui-workspace-addons-filter
    :model-value="modelValue"
    :disabled="disabled"
    :placeholder="$t('manageWorkspaces.filters.addons')"
    :bundles-label="$t('subscriptions.bundles.title')"
    :modules-label="$t('subscriptions.modules.title')"
    :addons-label="$t('subscriptions.addons.title')"
    :search-placeholder="$t('general.search')"
    :get-item-label="getAddonFilterTranslation"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #item-title="{ item }">
      {{ getAddonFilterTranslation(item) }}
    </template>
  </cui-workspace-addons-filter>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import { CuiWorkspaceAddonsFilter, type WorkspaceAddonFilterItem } from "@coronet/cui";
import { i18n } from "@/plugins/i18n";

/** Resolves an addon filter item to its i18n-translated display label based on type. */
export function getAddonFilterTranslation(item: WorkspaceAddonFilterItem): string | null {
  switch (item.type) {
    case "addon":
      return i18n.global.t(`subscriptions.addons.${item.name}`);
    case "module":
      return i18n.global.t(`subscriptions.modules.${item.name}`);
    case "bundle":
      return i18n.global.t(`subscriptions.bundles.${item.name}`);
    default:
      return null;
  }
}

/**
 * Workspace "Subscription" (bundles / modules / addons) filter with an in-dropdown search.
 * Thin wrapper over `@coronet/cui`'s `CuiWorkspaceAddonsFilter`: keeps this component's simple
 * `v-model` + `disabled` API (so the call sites stay untouched) and wires the translated group
 * labels, the search placeholder and the label resolver used for both display and filtering.
 */
export default defineComponent({
  components: { CuiWorkspaceAddonsFilter },
  props: {
    /** Selected bundle/module/addon items (v-model). */
    modelValue: {
      type: Array as PropType<WorkspaceAddonFilterItem[]>,
      required: true,
    },
    /** Disables the select. */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup() {
    return { getAddonFilterTranslation };
  },
});
</script>
